<template lang="jade">
  div.Tag(v-show="isConfirmed" v-el:tags)
    div.Tag__line {{ formData | tagline}}
    div.Tag__action(@click="isConfirmed = false")
  div(v-show="!isConfirmed")
    component(v-for="input in content"
              ":is"="input.type"
              ":fdata"="input")
    div.Button-group
      button.Button(type="button"
                    class="Button--secondary"
                    skin="sovereign"
                    @click="remove")
        span.Button__text Remove
      button.Button(type="button"
                    class="Button--primary"
                    skin="sovereign"
                    @click="confirm")
        span.Button__text Confirm
</template>

<script>
import _ from 'lodash'
import Moment from 'moment'
import type_rawHtml from './rawHtml'
import {addNotification} from 'src/vuex/actions'

export default {
  data () {
    return {
      pid: this.$parent.identity,
      isConfirmed: false,
      required: true,
      mandatory: true,
      formData: {},
      uid: this.$parent.uid
    }
  },
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  filters: {
    tagline (data) {
      if (_.isEmpty(data)) return ''
      let keys = ['W.CMS.SINGLE.A.FIELD3',
                  'W.CMS.SINGLE.A.FIELD6',
                  'W.CMS.SINGLE.A.FIELD4',
                  'W.CMS.SINGLE.D.FIELD5',
                  'W.CMS.SINGLE.A.FIELD2']
      return _.map(keys, idx => {
        if (_.isNil(data[idx] || _.isEmpty(data[idx]))) return ''
        if (_.isArray(data[idx])) return data[idx].join(' ')
        if (idx === 'W.CMS.SINGLE.A.FIELD2') return ' - LEVEL ' + parseInt(data[idx])
        if (idx === 'W.CMS.SINGLE.D.FIELD5') {
          return ' - ' + Moment(data[idx]).format('DD/MM/YYYY')
        }
        return data[idx]
      }).join(' ')
    }
  },
  vuex: {
    actions: {
      addNotification
    }
  },
  components: {
    type_rawHtml
  },
  events: {
    // collect data from form fields
    'fdata::input' (input) {
      this.formData = Object.assign({}, this.formData, input)
    },
    'force::submit' () {
      let vals = _.values(this.formData)
      let data = _.filter(vals, x => !_.isEmpty(x))
      if (data.length === vals.length) {
        this.confirm()
        this.$parent.show = true
      }
    }
  },
  methods: {
    confirm (e) {
      if (this.validate()) {
        let y = document.getElementById(this.pid).offsetTop
        window.scrollTo(0, y)
        let ph = document.querySelector(`#${this.pid} > .Fieldset__header`)
        ph.style.display = 'none'
        this.clearErrors()
        this.$set('isConfirmed', true)
        this.$dispatch('fdata::group', this.formData)
      }
    },
    validate () {
      let v = []
      _.forEach(this.$children, c => {
        if (!_.isUndefined(c.formInput) || !_.isUndefined(c.selected)) {
          let input = _.isUndefined(c.formInput) ? c.selected.value : c.formInput
          let field = {
            validation: [{ msg: c.fdata.label === 'Your partner\'s cover' ? 'Please select a level of cover for your partner' : `Please provide your partner’s ${c.fdata.label.toLowerCase()}`,
                           rule: 'required' }],
            field: c.fdata.field
          }
          let valid = this.computedValidate(field, input)
          if (!_.isNull(valid)) {
            this.$broadcast('external::error', {[field.field]: valid})
            this.addNotification({type: 'error',
                                  msg: valid,
                                  id: _.uniqueId(),
                                  timeout: 6000,
                                  onComplete: 'remove',
                                  show: true})
          }
          v.push(valid)
        }
      })
      return v.filter(x => !_.isNull(x)).length < 1
    },
    remove () {
      let ph = document.querySelector(`#${this.pid} > .Fieldset__header`)
      ph.style.display = 'flex'
      // this.$dispatch('fdata::remove', _.keys(this.formData))
      this.$dispatch('fdata::group', _.mapValues(this.formData, x => ''))
      this.clearErrors()
      this.$set('formData', {})
      this.$broadcast('clear')
      this.$set('isConfirmed', false)
    },
    clearErrors () {
      _.forEach(_.drop(this.content, 2), x => {
        this.$broadcast('external::error', {[x.field]: null})
      })
    }
  },
  ready () {
    let vals = _.values(this.formData)
    let data = _.filter(vals, x => !_.isEmpty(x))
    if (data.length === vals.length) {
      this.confirm()
      this.$parent.show = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// singlepart.vue?0f57210a